import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ITest } from '../types';
import {
  comparisonPopulationAggregatesProvider,
  IComparisonAggregates,
} from './aggregatesProvider';
import { calculateStatistics } from './utils/calculateStatistics';

export interface IScoringState {
  aggregates: IComparisonAggregates;
  test: ITest;
}

/**
 * @description
 * @param test
 * @returns
 */
export const scoringProvider = (test: ITest): Observable<IScoringState> => {
  return comparisonPopulationAggregatesProvider(
    `athletes:${test?.athleteId}`,
    test.queryHash as string,
    test.sessionId?.toString() as string
  ).pipe(
    map((aggregates: IComparisonAggregates): IComparisonAggregates => {
      const comparisonPopulation = aggregates.combined;
      if (comparisonPopulation) {
        const aggregatesWithStatistics = calculateStatistics(
          test,
          comparisonPopulation?.data,
          aggregates.settings?.zScorePreference
        );
        aggregates.combined.data = aggregatesWithStatistics;
      }

      return aggregates;
    }),
    map(
      (aggregates: IComparisonAggregates): IScoringState => ({
        aggregates,
        test,
      })
    )
  );
};
